import React, { useContext } from "react";
import Seo from "../Seo";
import { Helmet } from "react-helmet";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import Header from "./Header";
import { ToastContainer } from "react-toastify";
import Footer from "./Footer";
import { MyContext } from "../MyProvider";
import axios from "axios";
import { scAxiosAdmin } from "../../index";
import ReactHtmlParser from "react-html-parser";

const Cart = () => {
  const { state, removeFromCart } = useContext(MyContext);
  const cartData = JSON.parse(localStorage.getItem("cart"));
  const totalAmount = JSON.parse(localStorage.getItem("totalAmount"));
  const totalQuantity = JSON.parse(localStorage.getItem("totalQuantity"));
  const handleSubmit = async () => {
    let date = new Date();
    var formattedDate =
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2);

    let patient_id = localStorage.getItem("USER_ID");
    let qty = totalQuantity;
    let currency = "BDT";
    let type = "all";
    let total = totalAmount;
    let grand_total = totalAmount;
    let customer_data = {
      customer_name: localStorage.getItem("patient_name"),
      phone_number: localStorage.getItem("login_phone_number"),
    };
    let additional = cartData;
    let payment_type = "sslCommerz";
    let sslCommerz_urls = {
      success_url: `${window.location.origin}/success-order`,
      fail_url: `${window.location.origin}/fail`,
      cancel_url: `${window.location.origin}/cancel`,
    };
    let status = 1;

    // console.log("your log output", window);

    const postData = {
      date: formattedDate,
      patient_id,
      qty,
      total,
      type,
      currency,
      grand_total,
      customer_data,
      additional,
      payment_type,
      sslCommerz_urls,
      status,
    };

    try {
      const response = scAxiosAdmin
        .post("ledger", postData, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": `application/json`,
          },
        })
        .then((response) => {
          if (response.data.status === "success") {
            window.location.href = response.data.data;
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div>
      <Seo
        title="Cart | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Cart"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div style={{ backgroundColor: "#fef3e9" }}>
        <section className="banner-hero">
          <img
            src="/static/media/banner-profile.f160a4c1.jpg"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section className="prof-dr py-5">
          <div className="container">
            <div className="box-of-about border-part">
              <div class="container">
                <div class="row gy-4">
                  {cartData ? (
                    cartData.length > 0 ? (
                      cartData.map((cart, index) => (
                        <div key={index} className="col-sm-12">
                          <div
                            className="card shadow-md  bg-body"
                            style={{
                              borderLeft: "10px solid #55A5A6",
                              borderRadius: "10px",
                            }}
                          >
                            <div className="card-body d-flex justify-content-between align-items-center">
                              {/* <div className="" style={{ width: "10%" }}>
                              <img
                                src="/assets/images/shopping-cart.png"
                                alt="logo2"
                              />
                            </div> */}
                              <div
                                className=""
                                style={{ width: "80%", maxWidth: "1019px" }}
                              >
                                {cart.type === "investigation" ? (
                                  <div>
                                    <h4>Type : Investigation</h4>
                                    <h5 className="card-title">
                                      Product Group: {cart.Product_Group}
                                    </h5>
                                    <p className="card-text">
                                      Product Name: {cart.Product_Name}
                                    </p>
                                  </div>
                                ) : cart.type === "packages" ? (
                                  <div>
                                    <h4>Type : Packages</h4>
                                    <h5 className="card-title">{cart.name}</h5>
                                    <p className="card-text">
                                      {ReactHtmlParser(
                                        cart.description.slice(0, 50)
                                      )}
                                      {"..."}
                                    </p>
                                  </div>
                                ) : (
                                  <p></p>
                                )}
                              </div>
                              <div
                                className="d-flex flex-column align-items-end "
                                style={{ width: "20%" }}
                              >
                                <div className="">
                                  <i
                                    style={{ cursor: "pointer" }}
                                    className="fa-regular fa-circle-xmark"
                                    onClick={() =>
                                      removeFromCart(cart.id, cart.type)
                                    }
                                  ></i>
                                </div>
                                <div className="d-flex justify-content-around align-items-center w-100">
                                  {cart.type === "medicine" ? (
                                    <div className="d-flex justify-content-between align-items-center w-50">
                                      <div className="w-25">
                                        <i
                                          style={{ fontSize: "40px" }}
                                          className="fa-regular fa-square-plus"
                                        ></i>
                                      </div>
                                      <div className="w-25">
                                        <input
                                          className="form-control"
                                          id="exampleInputEmail1"
                                          aria-describedby="emailHelp"
                                        />
                                      </div>
                                      <div className="w-25">
                                        <i
                                          style={{ fontSize: "40px" }}
                                          className="fa-regular fa-square-minus"
                                        ></i>
                                      </div>
                                      <div className="w-50 text-end">
                                        Price: BDT 350
                                      </div>
                                    </div>
                                  ) : cart.type === "investigation" ? (
                                    ""
                                  ) : cart.type === "packages" ? (
                                    <div className="w-50 text-end">
                                      Price: {cart.opd_amount}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {/* <div className="w-50 text-end">
                                    Price: {cart.opd_amount}
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <h1 className="text-center">No data in cart</h1>
                    )
                  ) : (
                    ""
                  )}
                </div>
                {cartData ? (
                  cartData.length > 0 ? (
                    <div>
                      <div className="d-flex justify-content-between mt-5">
                        <h3>Total Amount:</h3>
                        <h3>BDT {totalAmount}</h3>
                      </div>
                      <div className="d-flex justify-content-center mt-5">
                        <button
                          // disabled={cartData.length > 0 ? false : true}
                          style={{ backgroundColor: "#187979", width: "15%" }}
                          className="btn  btn-sm rounded rounded-lg invBtn"
                          onClick={() => handleSubmit()}
                        >
                          Pay Now
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Cart;



// WEBPACK FOOTER //
// ./src/component/frontend/Cart.js